import { render, staticRenderFns } from "./RoleGrantView.vue?vue&type=template&id=42779120&scoped=true&"
import script from "./RoleGrantView.vue?vue&type=script&lang=js&"
export * from "./RoleGrantView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42779120",
  null
  
)

export default component.exports